/** The number leads are handed to you from, and that you can text for help. */
export const FF_ASSISTANT_NUMBER = '+17198004343'
export const FF_ASSISTANT_NUMBER_PRETTY = '(719) 800-4343'

/** Where a Follow Up Boss admin creates an API key. */
export const FUB_API_KEY_URL = 'https://app.followupboss.com/2/api'

/** Where the wizard lives, for calendar redirects back. */
export const WIZARD_PATH = '/onboarding'

/** Where setup hands off: the first campaign. */
export const FIRST_CAMPAIGN_PATH = '/campaign/flow/new'

export const MAX_AREA_CODES = 3

/** Tags sent to the stage-mapping suggestion service; more than this timed out at the gateway. */
export const MAX_SUGGESTION_TAGS = 60
